import get from 'lodash-es/get'
import * as React from 'react'

import { IItemCard } from '../interface'
import Tags from '../lockupTags'

import * as styles from './lockupTagsOnMobile.module.css'

interface IProps extends IItemCard {
  tags: string
  term: string
}

const LockupTagsOnMobile = ({ item, tags, term }: IProps) => {
  return (
    <section className={styles.tags}>
      <Tags item={item} tags={tags} term={term} expandable={false} />
    </section>
  )
}

export default LockupTagsOnMobile
